"use client";

import Logo from "./Logo";
import Notice from "./Notice";
import Button from "./Button";
import { worldCreateScreen } from "../worlds/registry";
import { AccountView } from "@/lib/types";

/** 選ばれた世界のキャラクター作成画面を出す */
export default function WorldCreateScreen({
  world,
  region,
  account,
  requestId,
  onBack,
  onDone,
}: {
  world: string;
  region: string;
  account: AccountView;
  requestId: string | null;
  onBack: () => void;
  onDone: (account?: AccountView) => void;
}) {
  const Screen = worldCreateScreen(world);

  if (Screen) {
    return <Screen region={region} account={account} requestId={requestId} onBack={onBack} onDone={onDone} />;
  }

  return (
    <div className="panel">
      <Logo />
      <Notice>
        <p>{world} のキャラクター作成画面は未実装です。</p>
      </Notice>
      <div className="foot">
        <Button onClick={onBack} inline>
          戻る
        </Button>
      </div>
    </div>
  );
}
